export default "__VITE_ASSET__CwICwjBH__"